export var ERROR_SUFFIX_HDCP_DECODE = 'HDCP_DECODE';
export var ERROR_SUFFIX_WINDOWS_HDCP_DECODE = 'WINDOWS_HDCP_DECODE';

//# sourceMappingURL=error-types.js.map